export enum RecaptchaAction {
  CONTACT_US_FORM = 'CONTACT_US_FORM',
  USER_TENTH_FILE = 'USER_TENTH_FILE'
}

export const checkRecaptcha = async (action: RecaptchaAction) => {
  // Wait for grecaptcha to be defined
  let attempts = 0;
  while (typeof (window as any).grecaptcha === 'undefined' && attempts < 50) {
    await new Promise((resolve) => setTimeout(resolve, 100));
    attempts++;
  }

  if (typeof (window as any).grecaptcha === 'undefined') {
    throw new Error('reCAPTCHA failed to load');
  }

  return (window as any).grecaptcha.enterprise.execute('6LdTBU0pAAAAADRKYKHpz0ZAlzvW1X41C5l8vBzJ', {
    action: action || RecaptchaAction.USER_TENTH_FILE
  });
};
